import { ICompanyLogo } from './company-logo';
import { ICompanyLogoSelect } from './company-logo-selects';

export interface ICompanyLogosResponse {
    logo_settings: ICompanyLogo[];
    select_values: ICompanyLogoSelect;
}
